/*
 * Blessac "Your set" picker — matching bag<->wallet cross-sell.
 * Ported from Afroyla's set picker, trimmed (no coupon strip) and adapted
 * for Broadcast v3: updates the add-to-cart label directly and submits
 * anchor + ticked members through /cart/add.js in one call, then hands
 * control back to the theme via theme:cart:refresh / theme:product:added.
 */
(function () {
  'use strict';

  function money(cents) {
    return window.theme && typeof window.theme.formatMoney === 'function'
      ? window.theme.formatMoney(cents, window.theme.moneyFormat)
      : '$' + (cents / 100).toFixed(2);
  }

  function scopeOf(node) {
    return node.closest('.shopify-section') || node.closest('[data-section-id]') || document;
  }

  function init(picker) {
    if (picker.__init) return;
    picker.__init = true;

    var scope = scopeOf(picker);
    var island = picker.querySelector('[data-set-members-data]');
    var members = {};
    try { members = JSON.parse(island.textContent); } catch (e) { return; }

    function anchor() {
      return {
        vid: parseInt(picker.getAttribute('data-anchor-vid'), 10),
        cents: parseInt(picker.getAttribute('data-anchor-cents') || '0', 10),
        compare: parseInt(picker.getAttribute('data-anchor-compare') || '0', 10)
      };
    }

    function checkedMembers() {
      var out = [];
      picker.querySelectorAll('[data-set-member]').forEach(function (row) {
        var input = row.querySelector('[data-set-member-input]');
        if (input && input.checked) out.push(members[row.getAttribute('data-member-idx')]);
      });
      return out.filter(Boolean);
    }

    function totals() {
      var a = anchor();
      var items = [a].concat(checkedMembers());
      var cents = 0;
      var compare = 0;
      items.forEach(function (it) {
        cents += it.cents;
        compare += Math.max(it.compare || 0, it.cents);
      });
      return { cents: cents, compare: compare, count: items.length };
    }

    // The Broadcast buy button keeps its label in [data-add-to-cart-text].
    // Remember the theme's own label so the solo state can restore it.
    function atcText() {
      var form = scope.querySelector('form[data-product-form]');
      return form ? form.querySelector('[data-add-to-cart-text]') : null;
    }

    function refresh() {
      picker.querySelectorAll('[data-set-member]').forEach(function (row) {
        var input = row.querySelector('[data-set-member-input]');
        row.classList.toggle('is-checked', !!(input && input.checked));
      });

      var t = totals();
      var totalEl = picker.querySelector('[data-set-total]');
      if (totalEl) {
        if (t.count > 1) {
          totalEl.innerHTML = '';
          totalEl.appendChild(document.createTextNode('Your set — ' + t.count + ' pieces, '));
          var b = document.createElement('strong');
          b.textContent = money(t.cents);
          totalEl.appendChild(b);
          totalEl.appendChild(document.createTextNode('. '));
          if (t.compare > t.cents) {
            var save = document.createElement('span');
            save.className = 'blessac-set__saved';
            save.textContent = 'You save ' + money(t.compare - t.cents);
            totalEl.appendChild(save);
            totalEl.appendChild(document.createTextNode(' today.'));
          }
          totalEl.removeAttribute('hidden');
        } else {
          totalEl.setAttribute('hidden', '');
        }
      }

      var label = atcText();
      if (label) {
        if (!label.__setBase) label.__setBase = label.textContent.trim();
        label.textContent = t.count > 1 ? label.__setBase + ' — ' + money(t.cents) : label.__setBase;
      }
    }

    /* ---------- quickview ---------- */
    var qv = picker.querySelector('[data-set-qv]');
    var qvSlot = qv && qv.querySelector('[data-set-qv-slot]');
    var qvAdd = qv && qv.querySelector('[data-set-qv-add]');
    var qvIdx = null;

    function paintQvAdd() {
      if (!qvAdd || qvIdx === null) return;
      var row = picker.querySelector('[data-set-member][data-member-idx="' + qvIdx + '"]');
      var input = row && row.querySelector('[data-set-member-input]');
      if (input && input.checked) {
        qvAdd.textContent = 'Added ✓';
        qvAdd.classList.add('is-added');
      } else {
        qvAdd.textContent = 'Add to set — ' + money(members[qvIdx].cents);
        qvAdd.classList.remove('is-added');
      }
    }

    function openQv(idx) {
      if (!qv || !qvSlot || !members[idx]) return;
      var tpl = picker.querySelector('[data-set-qv-tpl="' + idx + '"]');
      if (!tpl) return;
      qvIdx = idx;
      qvSlot.innerHTML = '';
      qvSlot.appendChild(tpl.content.cloneNode(true));
      paintQvAdd();
      qv.removeAttribute('hidden');
      document.documentElement.classList.add('blessac-set-qv-open');
    }

    function closeQv() {
      if (!qv) return;
      qv.setAttribute('hidden', '');
      qvIdx = null;
      document.documentElement.classList.remove('blessac-set-qv-open');
    }

    if (qv) {
      qv.addEventListener('click', function (event) {
        if (event.target.closest('[data-set-qv-close]')) closeQv();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !qv.hasAttribute('hidden')) closeQv();
      });
      if (qvAdd) {
        qvAdd.addEventListener('click', function () {
          if (qvIdx === null) return closeQv();
          var row = picker.querySelector('[data-set-member][data-member-idx="' + qvIdx + '"]');
          var input = row && row.querySelector('[data-set-member-input]');
          if (input && !input.checked) {
            input.checked = true;
            refresh();
            paintQvAdd();
            window.setTimeout(closeQv, 450);
          } else {
            closeQv();
          }
        });
      }
    }

    picker.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-set-qv-open]');
      if (opener) {
        event.preventDefault();
        event.stopPropagation();
        openQv(opener.getAttribute('data-set-qv-open'));
      }
    });

    picker.addEventListener('change', function (event) {
      if (event.target.matches('[data-set-member-input]')) refresh();
    });

    /* ---------- variant + add-to-cart ---------- */
    document.addEventListener('theme:variant:change', function (event) {
      if (!scope.contains(event.target)) return;
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      picker.setAttribute('data-anchor-vid', variant.id);
      if (typeof variant.price === 'number') picker.setAttribute('data-anchor-cents', variant.price);
      picker.setAttribute('data-anchor-compare', variant.compare_at_price || 0);
      refresh();
    });

    var form = scope.querySelector('form[data-product-form]');

    function multiAdd(event) {
      var picked = checkedMembers();
      if (!picked.length) return; // solo — let the theme handle it

      event.preventDefault();
      event.stopImmediatePropagation();

      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var items = [{ id: anchor().vid, quantity: qty }];
      picked.forEach(function (m) {
        items.push({ id: m.vid, quantity: 1, properties: { _attach_source: 'blessac-set-picker' } });
      });

      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.classList.add('is-loading');

      fetch((window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed: ' + res.status);
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
        })
        .catch(function () {
          // fall back to the theme's own single-product flow
          picker.querySelectorAll('[data-set-member-input]').forEach(function (i) { i.checked = false; });
          refresh();
          if (form.requestSubmit) form.requestSubmit();
        })
        .then(function () {
          if (btn) btn.classList.remove('is-loading');
        });
    }

    if (form) {
      document.addEventListener('click', function (event) {
        var btn = event.target.closest && event.target.closest('[data-add-to-cart]');
        if (btn && btn.closest('form[data-product-form]') === form) multiAdd(event);
      }, true);
      form.addEventListener('submit', multiAdd, true);
    }

    refresh();
  }

  function adoptAll(root) {
    (root || document).querySelectorAll('[data-set-picker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { adoptAll(document); });
  } else {
    adoptAll(document);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var node = records[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-set-picker]')) init(node);
          else if (node.querySelector && node.querySelector('[data-set-picker]')) adoptAll(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
